import React from "react";
import getFileMediaType from "../../../function/getFileMediaType";
import getFileUrl from "../../../function/getFileUrl";
import isIGenesysFile from "../../../function/isIGenesysFile";
import { IGenesysFile } from "../../../interface/IMessage";

const localFileUrls = new WeakMap<File, string>();

const RenderMiniImage = ({ file }: { file: IGenesysFile | File }) => {
  const url = isIGenesysFile(file)
    ? getFileUrl(file)
    : (() => {
        const cachedUrl = localFileUrls.get(file);
        if (cachedUrl) return cachedUrl;

        if (typeof URL.createObjectURL !== "function") {
          return getFileUrl(file);
        }

        const objectUrl = URL.createObjectURL(file);
        localFileUrls.set(file, objectUrl);
        return objectUrl;
      })();

  if (!url) return <></>;

  return (
    <img
      src={url}
      alt="file"
      style={{
        position: "relative",
        maxWidth: "100%",
        borderRadius: "10px",
        aspectRatio: "4/3",
      }}
    />
  );
};

const renderFileTypeIcon = (file: IGenesysFile | File): React.JSX.Element => {
  const mediaType = getFileMediaType(file).toLowerCase();

  if (mediaType === "image" || mediaType.startsWith("image/")) {
    return <RenderMiniImage file={file} />;
  }

  return <></>;
};

export default renderFileTypeIcon;
